export default __webpack_public_path__ + "fonts/cp_bg3.77c2a227fac4de0c4357ff1ef04d86a8.png";